module.exports = __webpack_public_path__ + "static/img/freshman-blocky__en-hover.1c69f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-blocky__en-hover.png
// module id = w55v
// module chunks = 1